import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PaymentWizardSettingsStore } from './payment-wizard-settings.store';
import { Observable } from 'rxjs';
import { LanguageService } from '../../../core/services/language/language.service';
import { SettingsQuery } from '../settings/settings.query';
import { CompanyQuery } from '../company/company.query';
import { ClinicDetailQuery } from '../clinic-detail/clinic-detail.query';
import { UserQuery } from '../user/user.query';
import { ServiceWizardQuery } from '../service-wizard/service-wizard.query';
import { PaymethodWizardService } from '../paymethod-wizard/paymethod-wizard.service';

import { PaymethodWizardQuery } from '../paymethod-wizard/paymethod-wizard.query';
import { PaymentWizardSettingsQuery } from './payment-wizard-settings.query';
import { ProductWizardQuery } from '../product-wizard/product-wizard.query';
import { TreatmentWizardSettingsQuery } from '../treatment-wizard-settings/treatment-wizard-settings.query';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class PaymentWizardSettingsService {
    constructor(
        private paymentWizardSettingsStore: PaymentWizardSettingsStore,
        private http: HttpClient,
        private languageService: LanguageService,
        private settingsQuery: SettingsQuery,
        private companyQuery: CompanyQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private userQuery: UserQuery,
        private serviceWizardQuery: ServiceWizardQuery,
        private paymethodWizardService: PaymethodWizardService,
        private paymethodWizardQuery: PaymethodWizardQuery,
        private paymentWizardSettingsQuery: PaymentWizardSettingsQuery,
        private productWizardQuery: ProductWizardQuery,
        private treatmentWizarSettingsQuery: TreatmentWizardSettingsQuery,
        private apiService: ApiService
    ) {}

    /*-----------*/
    /** UPDATES */
    /*----------*/

    seturlPayment(newUrlPayment: string) {
        this.paymentWizardSettingsStore.update({
            urlPayment: newUrlPayment,
        });
    }

    /*---------------*/
    /** LLAMADAS API */
    /*---------------*/

    /**
     * Llamada api para obtener la configuración del pago del asistente
     */
    private getPaymentWizardSettingsApi(
        systemKey: string,
        tokenId: string,
        clinicId: string,
        products: string[]
    ): Observable<any> {
        let params = new HttpParams();
        params = params.append('SystemKey', systemKey);
        params = params.append('ClientToken', tokenId);
        params = params.append('ClinicID', clinicId);
        params = params.append('Products', products.join(','));
        params = params.append('PayMethodID', undefined);
        params = params.append('Url', undefined);
        params = params.append('Cmd', 'c2002');
        params = params.append('Locale', this.languageService.getLocale());

        return this.apiService.callApi(params);
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    /** Llama a la API para obtener la información de pago del asistente y rellena los Stores */
    async getPaymentWizardSettings() {
        /** Los servicios seleccionados los cogemos de Akita */
        const servicesChekedArrayId = [];
        const servicesCheked = this.serviceWizardQuery
            .getAll({
                filterBy: ({ checked }) => checked === true,
            })
            .forEach((service) => {
                servicesChekedArrayId.push(service.id);
            });

        const paymentWizardSettingsData = await this.getPaymentWizardSettingsApi(
            this.settingsQuery.systemKeyURL,
            this.userQuery.tokenId,
            this.clinicDetailQuery.id,
            servicesChekedArrayId
        ).toPromise();

        this.paymentWizardSettingsStore.update({
            clinicAppSchedAndBuy:
                paymentWizardSettingsData.CheckOptions.ClinicAppSchedAndBuy,
            productList: paymentWizardSettingsData.CheckOptions.ProductList,
        });
        this.paymethodWizardService.setPaymethodsWizardByApi(
            paymentWizardSettingsData.PayMethods
        );
    }

    createUrlPaymentByTreatment() {
        const paymethod = this.paymethodWizardQuery.getActive();
        const systemKey = this.settingsQuery.systemKeyURL;
        const locale = this.languageService.getLocale();
        const tokenId = this.userQuery.tokenId;
        const clinicId = this.clinicDetailQuery.id;

        /** Los servicios seleccionados los cogemos de Akita */
        const productsWithUnitsId = [];
        const productsWithUnitsUnits = [];
        this.productWizardQuery
            .getAll({
                filterBy: ({ unitsCart }) => unitsCart > 0,
            })
            .forEach((product) => {
                productsWithUnitsId.push(product.id);
                productsWithUnitsUnits.push(product.unitsCart);
            });

        const shippingChoiceUser = this.treatmentWizarSettingsQuery
            .cancelShippingUserChecked
            ? '0'
            : this.treatmentWizarSettingsQuery.confirmShippingUserChecked
            ? '-1'
            : '';

        const shippingAddress =
            this.treatmentWizarSettingsQuery.shippingEnabled !== 0
                ? encodeURIComponent(
                      this.treatmentWizarSettingsQuery.shippingAddress
                  )
                : '';
        const urlPayment = `${
            paymethod.url
        }?SystemKey=${systemKey}&Locale=${locale}&ClientToken=${tokenId}&ClinicID=${clinicId}&Products=${productsWithUnitsId.join(
            ','
        )}&ProductUnits=${productsWithUnitsUnits.join(',')}&PayMethodID=${
            paymethod.id
        }&Shipping=${shippingChoiceUser}&ShippingAddress=${shippingAddress}`;
        this.paymentWizardSettingsStore.update({
            urlPayment,
        });
    }

    createUrlPaymentByAppointment() {
        const paymethod = this.paymethodWizardQuery.getActive();
        const systemKey = this.settingsQuery.systemKeyURL;
        const locale = this.languageService.getLocale();
        const tokenId = this.userQuery.tokenId;
        const clinicId = this.clinicDetailQuery.id;
        const productList = this.paymentWizardSettingsQuery.productList;

        const urlPayment = `${paymethod.url}?SystemKey=${systemKey}&Locale=${locale}&ClientToken=${tokenId}&ClinicID=${clinicId}&Products=${productList}&PayMethodID=${paymethod.id}`;
        this.paymentWizardSettingsStore.update({
            urlPayment,
        });
    }

    resetUrlPayment() {
        this.paymentWizardSettingsStore.update({
            urlPayment: '',
        });
    }

    resetStore() {
        this.paymentWizardSettingsStore.reset();
    }
}
